import { Injectable } from '@angular/core';

/**
 * Class for the WindowService
 * @class
 */
@Injectable()
export class WindowService {

  /**
   * Gets the window
   * @returns {Window}
   */
  get window() {
    return window;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/window/window.service.ts